import '../App.css';
import React, { useState, useEffect } from "react";
import { Row, Col, Container } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css'
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import pdf from '../pdfs/speciesaffection.pdf'; 
import { Helmet } from 'react-helmet';

function Page() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  function renderLinks() {
    return (
      <div style={{lineHeight: isMobile ? '1' : '', fontSize: isMobile ? '15px' : ''}}>
        Source:<br /><br />
		Manuscript held by G. W. Leibniz Bibliothek, Hanover<br />
		Shelfmark LH 35, 1, 14 Bl. 45<br /><br />
		{isMobile ? '' : <hr className="centered-hr" />}
		Date: autumn 1686 (?)<br /><br />
        Translated from the Latin<br /><br /> 
        {isMobile ? '' : <hr className="centered-hr" />}
        <Link to={pdf} target="_blank">View this translation in PDF format (254k)</Link>
      </div>
    );
  }
  
  return (
    <div>
        <Helmet>
            <title>Definition of “Species” and “Affection”</title>
            <meta name="description" content="An English translation of DEFINITION OF 'SPECIES' AND 'AFFECTION' by Gottfried Wilhelm Leibniz, from autumn 1686 (?)" />
        </Helmet>
        <Routes>
          <Route path="/" element={
            <Container fluid className="Container">
              <Row className="main-content">
                <Col md={3} className={`LeftColumn ${isMobile ? 'mobile' : ''}`}>
                  {isMobile ? (
                    <></>
                  ) : (
                    <>
                    {renderLinks()}<br></br>
                 
                    </>
                  )}
                </Col>
                <Col md={8} className={`RightColumn ${isMobile ? 'mobile' : ''}`}>
                  <h2 id='top' className={`PageTitle ${isMobile ? 'mobile' : ''}`}>LEIBNIZ: DEFINITION OF &quot;SPECIES&quot; AND &quot;AFFECTION&quot;</h2>
                  {isMobile ? (
                    <>
                    {renderLinks()}  
                    </>
                  ) : (
                    <>
                    
                    </>
                  )}
                 <br />
                 <small>Although the paper bears no watermark, Leibniz's attempts at defining &quot;species&quot; and &quot;affection&quot; in this piece are similar to those found in &quot;Definitions: Alike, Similar, Species, Affection&quot;,<a name="1" href="#note1"><sup>1</sup></a> suggesting that this piece is likely to have been written around the same time as that one.</small><br /><br /><br />
                  [<b>LH 35, 1, 14 Bl. 45v</b>]<br /><br />
                <br />
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;I define a <var>species</var> as an aggregate of affections. Now I attempt to define <var>affection</var>. If it is a relation of a thing to those things which are in it, then the relation of a circle to a circumscribed &#9634; would not be an affection of the circle. If it is a relation to those things which are determined as a result of the thing, then the relation of a circle to a point lying in the same plane but outside the circle will not be an affection of the circle either. I now attempt to define it as a relation of a thing to something already correlated with it — for example, the relation of a circle to its diameter. But in this way, the relation of a sphere to any point whatsoever will not be an affection; for example, a straight line drawn from that point to the centre meets the sphere's tangent plane at right angles at the point of contact. Therefore, it seems that an <var>affection</var> is a universal relation of notions — for example, between a point and a circle, between a circle and its diameter,<a name="2" href="#note2"><sup>2</sup></a> and between a point and a point. Consequently, 'being a foot long' is not an affection of a circle, nor is 'being situated in such-and-such a place'; for 'being a foot long'<a name="3" href="#note3"><sup>3</sup></a> cannot be demonstrated of any figure. The distance of one point from another is not an affection of the two points, but 'to have some distance' is.<a name="4" href="#note4"><sup>4</sup></a><br />
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;An affection is a necessary predicate of a universal term. Thus, even if it might perhaps happen that all human beings are shorter than ten feet tall, this is nevertheless not necessary, nor can any definite measure be ascribed to any notion. For God could increase or diminish the circumstance in proportion, without any inconsistency arising from it. Being two feet long may indeed be a necessary predicate of some particular straight line, yet there can be no [<b>LH 35, 1, 14 Bl. 45r</b>] species of straight lines for which it is necessary to be two feet long. There are not several species of straight lines; rather, the straight line is the lowest species. The same is true of the circle, the square, and the parabola, but not of the rectangle, the ellipse, or the hyperbola.

                <br /><br /><br />
                <hr className='rightcol-hr' />
                <br /><br />
                NOTES:<br /><br />
                <a name="note1" href="#1">1.</a> See LH 35, 12, 1 Bl. 73v-74; English translation in <var>Leibniz: Philosophical Papers, 1677-1686. Universal Language, Characteristic, Logic, Encyclopaedia, and General Science</var>, edited and translated by Lloyd Strickland (Oxford: Oxford University Press, 2026), N. 59.<br />
                <a name="note2" href="#2">2.</a> diameter, │ but not between any two points │ <var>deleted</var>.<br />
                <a name="note3" href="#3">3.</a> long' │ cannot be demonstrated of any notion │ <var>deleted</var>.<br />
                <a name="note4" href="#4">4.</a> is. │ Likewise with regard to such a relation defined between one circle and another │ <var>deleted</var>.<br />
                <br /><br /><br />

                <br /><br /><br />
                &#169; Lloyd Strickland 2025
                <br></br><br></br>
                </Col>
                <Col md={1}></Col>
              </Row>
              <Row className="footer"><h6>&copy; LLOYD STRICKLAND 2003-{new Date().getFullYear()}</h6></Row>
            </Container>
          } />
        </Routes>
      </div>
  );
}

export default Page;
